import {format, parseISO} from "date-fns";

import {Text} from "@pg-design/text-module";

export interface IDataTableCellDateTimeRendererProps {
    value: string;
    dateFormat?: string;
}

export const DataTableCellDateTimeRenderer = ({value, dateFormat = "dd.MM.yyyy HH:mm:ss"}: IDataTableCellDateTimeRendererProps) => {
    const dateTime = format(parseISO(value), dateFormat);

    return <Text variant="body_copy_1">{dateTime}</Text>;
};
import {format, parseISO} from "date-fns";

import {Text} from "@pg-design/text-module";

export interface IDataTableCellDateTimeRendererProps {
    value: string;
    dateFormat?: string;
}

export const DataTableCellDateTimeRenderer = ({value, dateFormat = "dd.MM.yyyy HH:mm:ss"}: IDataTableCellDateTimeRendererProps) => {
    const dateTime = format(parseISO(value), dateFormat);

    return <Text variant="body_copy_1">{dateTime}</Text>;
};
